import axios from 'axios';

export default {
  selectors: (params = {}, config = {}) => axios.get('currencies/selectors', { params, ...config }),
};
